import React from 'react';
import { motion } from 'framer-motion';

const ChamberDoorway = ({ title }) => {
  return (
    <motion.div 
      initial={{ opacity: 0, scaleX: 0 }}
      whileInView={{ opacity: 1, scaleX: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8 }}
      className="my-16 flex flex-col items-center gap-6"
    >
      {/* Decorative line */}
      <div className="w-full max-w-3xl h-px bg-gradient-to-r from-transparent via-[#00F0FF] to-transparent shadow-[0_0_8px_rgba(0,240,255,0.4)]"></div>
      
      {/* Chamber title */}
      {title && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="px-8 py-3 glass-surface border border-[#00F0FF]/40 rounded-full"
        >
          <h2 className="text-xl sm:text-2xl font-black text-white tracking-wide">
            {title}
          </h2>
        </motion.div>
      )}
      
      {/* Bottom decorative line */}
      <div className="w-full max-w-3xl h-px bg-gradient-to-r from-transparent via-[#FF00FF] to-transparent shadow-[0_0_8px_rgba(255,0,255,0.4)]"></div>
    </motion.div>
  );
};

export default ChamberDoorway;
